import React from "react";
import Checkbox from "@mui/material/Checkbox";

function AdmissionAssessorRedFlags({
  bipolar12,
  handleBipolar12Change,
  previousPersonalityDisorder,
  handlePreviousPersonalityDisorderChange,
  activePsychosis,
  handleActivePsychosisChange,
  diagnosisWithPsychoticFeatures,
  handleDiagnosisWithPsychoticFeaturesChange,
  recentSelfHarm,
  handleRecentSelfHarmChange,
  violentBehavior,
  handleViolentBehaviorChange,
  historyOfSeizure,
  handleHistoryOfSeizureChange,
  activeFoodRestriction,
  handleActiveFoodRestrictionChange,
  currentMobilityIssues,
  handleCurrentMobilityIssuesChange,
  currentComplexMedicalIssues,
  handleCurrentComplexMedicalIssuesChange,
  suicidalIdeation,
  handleSuicidalIdeationChange,
  suicideAttempt,
  handleSuicideAttemptChange,
  noneApply,
  handleNoneApplyChange,
}) {
  return (
    <div className="container-main-plan-red">
      <div className="tab-container-title" style={{ paddingLeft: 20 }}>
        Assessor, complete the following based on the above pre-admission
        information (â€œred flag(s)â€ for admission)
      </div>
      <div className="tab-container-subtitle">Check any that apply:</div>
      <div className="yes-no-container">
        <Checkbox checked={bipolar12} onChange={handleBipolar12Change} />
        <div className="sentence-yes-no">Bipolar I or II</div>
      </div>
      <div className="yes-no-container">
        <Checkbox
          checked={previousPersonalityDisorder}
          onChange={handlePreviousPersonalityDisorderChange}
        />
        <div className="sentence-yes-no">
          previous personality disorder diagnosis: anti-social, narcissistic,
          or borderline
        </div>
      </div>
      <div className="yes-no-container">
        <Checkbox checked={activePsychosis} onChange={handleActivePsychosisChange} />
        <div className="sentence-yes-no">
          recent or current active psychosis
        </div>
      </div>
      <div className="yes-no-container">
        <Checkbox
          checked={diagnosisWithPsychoticFeatures}
          onChange={handleDiagnosisWithPsychoticFeaturesChange}
        />
        <div className="sentence-yes-no">
          mental health diagnosis with psychotic features
        </div>
      </div>
      <div className="yes-no-container">
        <Checkbox checked={recentSelfHarm} onChange={handleRecentSelfHarmChange} />
        <div className="sentence-yes-no">
          recent self-harm (within the past 3 months)
        </div>
      </div>
      <div className="yes-no-container">
        <Checkbox checked={violentBehavior} onChange={handleViolentBehaviorChange} />
        <div className="sentence-yes-no">violent crime or behavior</div>
      </div>
      <div className="yes-no-container">
        <Checkbox checked={historyOfSeizure} onChange={handleHistoryOfSeizureChange} />
        <div className="sentence-yes-no">history of seizure</div>
      </div>
      <div className="yes-no-container">
        <Checkbox
          checked={activeFoodRestriction}
          onChange={handleActiveFoodRestrictionChange}
        />
        <div className="sentence-yes-no">
          anorexia or bulimia or food restriction
        </div>
      </div>
      <div className="yes-no-container">
        <Checkbox
          checked={currentMobilityIssues}
          onChange={handleCurrentMobilityIssuesChange}
        />
        <div className="sentence-yes-no">current mobility issues</div>
      </div>
      <div className="yes-no-container">
        <Checkbox
          checked={currentComplexMedicalIssues}
          onChange={handleCurrentComplexMedicalIssuesChange}
        />
        <div className="sentence-yes-no">
          current complex medical issues (e.g., TBI, recent major surgeries)
        </div>
      </div>
      <div className="yes-no-container">
        <Checkbox checked={suicidalIdeation} onChange={handleSuicidalIdeationChange} />
        <div className="sentence-yes-no">
          suicidal ideation with intent or plan within the past month
        </div>
      </div>
      <div className="yes-no-container">
        <Checkbox checked={suicideAttempt} onChange={handleSuicideAttemptChange} />
        <div className="sentence-yes-no">
          suicide attempt within the past 3 months
        </div>
      </div>
      <div className="yes-no-container">
        <Checkbox checked={noneApply} onChange={handleNoneApplyChange} />
        <div className="sentence-yes-no">None apply</div>
      </div>
    </div>
  );
}

export default AdmissionAssessorRedFlags;

